import Axios from "axios";

const state = {
  contractsList: [],
  subcomponentsList: [],
  areasList: [],
  disciplinesList: [],
  documentTypesList: [],
  revisionsList: [],
  loading: false,
  error: null,
};

const getters = {
  getContractsList: (state) => state.contractsList,
  getSubcomponentsList: (state) => state.subcomponentsList,
  getAreasList: (state) => state.areasList,
  getDisciplinesList: (state) => state.disciplinesList,
  getDocumentTypesList: (state) => state.documentTypesList,
  getRevisionsList: (state) => state.revisionsList,
};

const actions = {
  async getContractsList({ commit }) {
    try {
      commit('setLoading', true);
      const response = await Axios.get('/api/auth/cms/appendix/contracts'); // FIXED: Added /auth/
      if (response.data.success) {
        commit('setContractsList', response.data.data);
        commit('setError', null);
      }
    } catch (error) {
      commit('setError', error.message);
      console.error('Error fetching contracts:', error);
    } finally {
      commit('setLoading', false);
    }
  },

  async getSubcomponentsList({ commit }) {
    try {
      commit('setLoading', true);
      const response = await Axios.get('/api/auth/cms/appendix/subcomponents'); // FIXED: Added /auth/
      if (response.data.success) {
        commit('setSubcomponentsList', response.data.data);
        commit('setError', null);
      }
    } catch (error) {
      commit('setError', error.message);
      console.error('Error fetching subcomponents:', error);
    } finally {
      commit('setLoading', false);
    }
  },

  async getAreasList({ commit }) {
    try {
      commit('setLoading', true);
      const response = await Axios.get('/api/auth/cms/appendix/areas'); // FIXED: Added /auth/
      if (response.data.success) {
        commit('setAreasList', response.data.data);
        commit('setError', null);
      }
    } catch (error) {
      commit('setError', error.message);
      console.error('Error fetching areas:', error);
    } finally {
      commit('setLoading', false);
    }
  },

  async getDisciplinesList({ commit }) {
    try {
      commit('setLoading', true);
      const response = await Axios.get('/api/auth/cms/appendix/disciplines'); // FIXED: Added /auth/
      if (response.data.success) {
        commit('setDisciplinesList', response.data.data);
        commit('setError', null);
      }
    } catch (error) {
      commit('setError', error.message);
      console.error('Error fetching disciplines:', error);
    } finally {
      commit('setLoading', false);
    }
  },

  async getDocumentTypesList({ commit }) {
    try {
      commit('setLoading', true);
      const response = await Axios.get('/api/auth/cms/appendix/documenttypes'); // FIXED: Added /auth/
      if (response.data.success) {
        commit('setDocumentTypesList', response.data.data);
        commit('setError', null);
      }
    } catch (error) {
      commit('setError', error.message);
      console.error('Error fetching document types:', error);
    } finally {
      commit('setLoading', false);
    }
  },

  async getRevisionsList({ commit }) {
    try {
      commit('setLoading', true);
      const response = await Axios.get('/api/auth/cms/appendix/revisions'); // FIXED: Added /auth/
      if (response.data.success) {
        commit('setRevisionsList', response.data.data);
        commit('setError', null);
      }
    } catch (error) {
      commit('setError', error.message);
      console.error('Error fetching revisions:', error);
    } finally {
      commit('setLoading', false);
    }
  },
};

const mutations = {
  setContractsList: (state, data) => state.contractsList = data,
  setSubcomponentsList: (state, data) => state.subcomponentsList = data,
  setAreasList: (state, data) => state.areasList = data,
  setDisciplinesList: (state, data) => state.disciplinesList = data,
  setDocumentTypesList: (state, data) => state.documentTypesList = data,
  setRevisionsList: (state, data) => state.revisionsList = data,
  setLoading: (state, loading) => state.loading = loading,
  setError: (state, error) => state.error = error,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};